module.exports = __webpack_public_path__ + "static/media/stamp.fbd88f50.png";